var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.state.userCurrentCompany)?_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":this.dashboardUrl,"id":"dashboard-frame","width":"1200px","height":"850px","allowfullscreen":"","frameborder":"0"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f27949e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Bold-Dashboard.vue
// module id = null
// module chunks = 